import globals from '../../globals';
import initialData from '../utils/initial-data';
import connectedStore from '../../store/connected-store';
import getAssetsToUpdate from '../utils/saving-action-creators/helpers/get-assets-to-update';

const modifiedGlobals = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const initialGlobals = initialData.getGlobals();
  const currentGlobals = globals.selectors.getGlobals(state);
  const globalsToUpdate = getAssetsToUpdate(initialGlobals, currentGlobals);

  return Boolean(globalsToUpdate.length);
};

export default modifiedGlobals;
